module.exports = __webpack_public_path__ + "img/balao_balao_6.0e07ce75.svg";